import { render, staticRenderFns } from "./swiperList.vue?vue&type=template&id=5683b292&scoped=true&"
import script from "./swiperList.vue?vue&type=script&lang=js&"
export * from "./swiperList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683b292",
  null
  
)

export default component.exports